module.exports = __webpack_public_path__ + "static/img/bg2.f34f9f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/bg2.png
// module id = qXXL
// module chunks = 1